import type { IBulkActionPayload } from "helpers/utils/bulk-manager";
import { BULK_MANAGER } from "../../constants/action-types";

export const openBulkManager = (type: string) => ({ type: BULK_MANAGER.OPEN, payload: type });
export const closeBulkManager = () => ({ type: BULK_MANAGER.CLOSE });
export const addBulkAction = (payload: IBulkActionPayload) => ({ type: BULK_MANAGER.ADD, payload });
export const removeBulkAction = (id: string) => ({ type: BULK_MANAGER.REMOVE, payload: { id } });
